import { FunctionComponent, FormEvent, useEffect, useState } from "react";
import { Checkbox, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { InternalNamePath } from "rc-field-form/lib/interface";
import { Rule } from "antd/es/form";
import { CheckboxChangeEvent } from "antd/es/checkbox";

interface PropsType {
  showLabel?: boolean;
  module: string;
  field: string | InternalNamePath;
  required?: boolean;
  emptyErrorMessage?: string;
  placeholder?: string;
  labelTooltip?: string | null;
  readOnly?: boolean;
  labelClassName?: string;
  fieldClassName?: string;
  maxLength?: number;
  onChange?: (val: boolean) => void;
  type?: string;
  addonAfter?: string;
  addonBefore?: string;
  textArea?: boolean;
  className?: string;
  fieldPrefix?: string;
  rules?: Rule[];
  onInput?: (e: FormEvent<HTMLInputElement>) => void;
  initialValue?: { [key in string]: string };
  disabled?: boolean;
  value?: boolean;
  isChecked: boolean;
}

const CheckboxFormField: FunctionComponent<PropsType> = (props: PropsType) => {
  const {
    showLabel,
    labelTooltip,
    module,
    field,
    readOnly,
    labelClassName,
    fieldClassName,
    onChange,
    disabled,
    value,
    isChecked,
  } = props;
  const { t } = useTranslation();

  const i18nField =
    typeof field === "string"
      ? field.split(".")[field.split(".").length - 1]
      : Array.isArray(field)
      ? (field[field.length - 1] as string).replace(/[0-9]/g, "")
      : "";

  const key = `field_${String(field)}`.replace(",", "_");

  const [checked, setChecked] = useState<boolean>(isChecked);

  const handleChange = (e: CheckboxChangeEvent) => {
    if (onChange) onChange(e.target.checked);
  };

  useEffect(() => {
    if (value != undefined) setChecked(value);
  }, [value]);

  return (
    <div className={"w-100 d-flex justify-content-between"}>
      {readOnly || showLabel ? (
        <span className={labelClassName ? labelClassName : ""}>
          {t(`${module}.form.fields.${i18nField}.label`)}&nbsp;
          {labelTooltip && <Tooltip title={labelTooltip} />}
        </span>
      ) : (
        ""
      )}
      <Checkbox
        checked={checked}
        disabled={readOnly || disabled}
        className={readOnly ? " readonly-form-field" : fieldClassName}
        id={key}
        onChange={handleChange}
      />
    </div>
  );
};

export default CheckboxFormField;
